export function normalizeCountryCode(country) {
    if (typeof country !== 'string') return 'CA';

    const normalized = country.trim().toUpperCase();

    if (normalized === 'US' || normalized === 'UNITED STATES') {
        return 'US';
    }

    if (normalized === 'CA' || normalized === 'CANADA') {
        return 'CA';
    }

    return 'CA';
}
